import { Moment } from 'moment';
import { API_URI, apiGet, apiPost, apiDelete } from './index';

const alert = {
    getAll: async (projectId: number) => {
        const data = await apiGet(`${API_URI}/api/alert/getall?projectId=${projectId}`);
        return data;
    },
    save: async (name: string, projectId: number, recipientIds: number[], interval: number, startDate: Moment) => {
        const data = await apiPost(`${API_URI}/api/alert/save`, {
            name: name,
            projectId: projectId,
            recipientIds: recipientIds.join(','),
            interval: interval,
            startDate: startDate.format("DD MMM YYYY HH:mm"),
        })
        return data;
    },
    delete: async (id: number) => {
        await apiDelete(`${API_URI}/api/alert/${id}`);
    }
}

export default alert;